import { ReactNode } from 'react';
import '../../../dashboard-reset.css';

interface ComponentActionItemProps {
  children: ReactNode;
}

export default function ComponentActionItem({
  children,
}: ComponentActionItemProps) {
  return (
    <div className="dashboard-reset action-item-card">
      {/* Header */}
      <div className="action-item-header">
        {children}
      </div>
    </div>
  );
}
